import React from 'react'
import Pt from 'prop-types'
import cx from 'classnames'

import { format as formatCurrency } from '../util/Currency'

export default function Currency({ amount, className }) {
  return (
    <span className={cx(className, { negative: amount < 0 })}>
      {formatCurrency(amount)}
    </span>
  )
}

Currency.propTypes = {
  amount: Pt.number.isRequired,
  className: Pt.string,
}



// WEBPACK FOOTER //
// ./deps/internal-components/src/components/Currency.jsx